module.exports = __webpack_public_path__ + "static/img/tongyimenhu.f926ecf.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/tongyimenhu.gif
// module id = /m0G
// module chunks = 0